import { FeatureIslandMainWithCategoryWrapper } from "@/components/features/_layouts";

import { QuestionRoomIsDormitory } from "./is-dormitory-type";

import type { StandardRoomCategoriesAndManagerStore } from "../../store/categories";

type Props = {
	dormitory: StandardRoomCategoriesAndManagerStore["dormitory"];
};

export const QuestionRoomDormitory = ({ dormitory }: Props) => {
	return (
		<FeatureIslandMainWithCategoryWrapper categoryStore={dormitory}>
			<QuestionRoomIsDormitory />
		</FeatureIslandMainWithCategoryWrapper>
	);
};

QuestionRoomDormitory.displayName = "QuestionRoomDormitory";
